class header extends HTMLElement {
  constructor() {
    super()
    this.megamenuSplitNav = this.querySelectorAll('.megaMenu__splitNav')

    this.lastScrollTop = 0

    this.megamenuSplitNav.forEach((nav) => {
      const megamenuSplitNavLinks = nav.querySelectorAll(
        '.megaMenu__linksList-link'
      )
      nav.addEventListener('mouseover', (e) => e.stopPropagation())
      if (!megamenuSplitNavLinks.length) return
      megamenuSplitNavLinks.forEach((link) => {
        link.addEventListener('mouseover', () => {
          this.showMegaMenuLinkContent(nav, link)
        })
        link.addEventListener('keydown', (e) => {
          if (
            e.key === 'Enter' &&
            e.target.classList.contains('megaMenu__linksList-link')
          )
            this.showMegaMenuLinkContent(nav, link)
        })
      })
    })

    document.body.addEventListener('mouseover', () => {
      this.megamenuSplitNav.forEach((nav) => {
        const defaultNav = nav.querySelector('[data-id="default"')
        if (defaultNav) {
          this.hideAllContent(nav)
          defaultNav.classList.remove('hidden')
        }
      })
    })

    window.addEventListener('scroll', () => this.scrollHandler())

    const menuExpandButtons = this.querySelectorAll('[data-open-megamenu]')
    menuExpandButtons.forEach((btn) => {
      const wrapper = btn.closest('li')
      btn.addEventListener('click', (e) => {
        this.toggleMegamenuOnClick(e, btn)
      })
      wrapper.addEventListener('focusout', (e) => {
        if (!wrapper.contains(e.relatedTarget)) {
          wrapper.removeAttribute('data-megamenu-open')
        }
      })
      wrapper.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          wrapper.removeAttribute('data-megamenu-open')
          const nextLink = wrapper.nextSibling.querySelector(
            '[data-open-megamenu]'
          )
          nextLink.focus()
        }
      })
    })
  }

  showMegaMenuLinkContent(nav, link) {
    const currentContent = nav.querySelector(
      `[data-id="${link.dataset.target}"]`
    )

    if (!currentContent) return

    this.hideAllContent(nav)
    currentContent.classList.remove('hidden')
  }

  hideAllContent(nav) {
    const productsLists = nav.querySelectorAll('.megaMenu__productsList')
    const marketingBanners = nav.querySelectorAll('.megaMenu__marketingBanner')
    productsLists.forEach((list) => list.classList.add('hidden'))
    marketingBanners.forEach((banner) => banner.classList.add('hidden'))
  }

  scrollHandler() {
    const currentScroll = window.scrollY || document.documentElement.scrollTop
    const headerEl = document.querySelector('#header')
    const html = document.querySelector('html')

    // if at end of page - do nothing
    if (
      window.innerHeight + Math.round(window.scrollY) >=
        document.body.offsetHeight ||
      html.classList.contains('drawer-open-html')
    ) {
      return
    }

    const isScrollingDown = currentScroll > this.lastScrollTop

    headerEl?.classList.toggle('nav-up', isScrollingDown)
    html.classList.toggle('nav-up-html', isScrollingDown)

    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll

    this.dispatchEvent(
      new CustomEvent('header:scroll', {
        detail: {
          direction: isScrollingDown ? 'down' : 'up',
          currentScroll,
          lastScrollTop: this.lastScrollTop,
        },
      })
    )
  }

  toggleMegamenuOnClick(e, btn) {
    if (e.target.hasAttribute('data-open-megamenu')) {
      const wrapper = btn.closest('li')
      if (wrapper.hasAttribute('data-megamenu-open')) {
        wrapper.removeAttribute('data-megamenu-open')
        btn.setAttribute('aria-expanded', false)
      } else {
        wrapper.setAttribute('data-megamenu-open', '')
        btn.setAttribute('aria-expanded', true)
      }
    }
  }
}

customElements.define('header-nav', header)
